import React from "react"
import { Link } from "gatsby"
const data = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  /* {
    id: 2,
    text: "about",
    url: "/about/",
  }, */
  {
    id: 2,
    text: "Lentor Modern factsheet",
    url: "/projects/lentor-modern",
  }, 
  {
    id: 3,
    text: "Lentor Modern Floor-Plans",
    url: "/floorPlanLentorModern/",
  },
  {
    id: 4,
    text: "Sky Eden factsheet",
    url: "/projects/sky-eden-bedok",
  }, 
  /* {
    id: 4,
    text: "blog",
    url: "/blog/",
  },  */   
  /* {
    id: 14,
    text: "location",
    url: "/location/",
  }, */
  /* {
    id: 13,
    text: "Landscape+Interior",
    url: "/landscapeIDDecor/",
  }, */
  
  /* {
    id: 10,
    text: "Amenities",
    url: "/amenities/",
  }, */
  /* {
    id: 9,
    text: "Why AMO ?",
    url: "/whyAMO/",
  },   */
  
  {
    id: 5,
    text: "Sky Eden Floor-Plans",
    url: "/floorPlanSkyEden/",
  },
  /* {
    id: 11,
    text: "Unit Selection",
    url: "/elevationChart/",
  }, */
  /* {
    id: 12,
    text: "Pricing",
    url: "/pricing/",
  }, */
  {
    id: 6,
    text: "contact",
    url: "/contact/",
  },
]


const tempLinks = data.map(link => {
  return (
    <li key={link.id}>
      <Link to={link.url}>{link.text}</Link>
    </li>
  )
})
// I KNOW WE CAN COMBINE IT !!!!!

export default ({ styleClass }) => {
  return (
    <ul className={`page-links ${styleClass ? styleClass : ""}`}>
      {tempLinks}
    </ul>
  )
}
